module.exports = __webpack_public_path__ + "img/sketch-bettype.9b5d4896.svg";